import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';
const RoleRoute = ({ roles, children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return _jsx("div", { children: "Chargement\u2026" });
    }
    if (!user || !user.role_hierarchy || !roles.includes(user.role_hierarchy)) {
        return _jsx(Navigate, { to: "/forbidden", replace: true });
    }
    return children;
};
export default RoleRoute;
